import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  background: var(--secondary-50);
  padding: var(--space-xl);
`;

const AdminTestimonials = () => {
  return (
    <Container>
      <h1>Testimonials Management</h1>
      <p>Admin interface for managing testimonials will be implemented here.</p>
    </Container>
  );
};

export default AdminTestimonials;